import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";

import React, { useState } from "react";

import FormAction from "../../../../../../components/common/FormAction";

import { SiMinutemailer } from "react-icons/si";
import { TbCurrencyDollar } from "react-icons/tb";
import { states } from "../../../../../../utils/Util";

function ResidentialHistory() {
  const [checked, setChecked] = useState(false);
  const [edit, setEdit] = useState(false);
  const [addPrevAddress, setAddPrevAddress] = useState(false);
  const onCancel = () => {
    setChecked(false);
  };

  const onCancelEdit = () => {
    setEdit(false);
  };

  const onCancelPrevAddress = () => {
    setAddPrevAddress(false);
  };
  return (
    <div className="residential-history">
      <Card
        title="Residential History"
        extra={
          <button className="icon-text-btn">
            <SiMinutemailer size={18} />
            <span>Email Verification</span>
          </button>
        }
      >
        <Form
          labelCol={{ span: 8 }}
          colon={false}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <Card
                extra={
                  !checked ? (
                    <span
                      className="onclick-text"
                      onClick={() => setChecked(true)}
                    >
                      Edit
                    </span>
                  ) : null
                }
              >
                {checked ? (
                  <Row>
                    <Col span={24}>
                      <Form.Item label="Current Address" required>
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <Input placeholder="Address" />
                          </Col>
                          <Col span={24}>
                            <Input placeholder="Address 2" />
                          </Col>
                          <Col span={24}>
                            <Row gutter={[8, 0]}>
                              <Col span={10}>
                                <Input placeholder="City" />
                              </Col>
                              <Col span={4}>
                                <Select options={states} />
                              </Col>
                              <Col span={10}>
                                <Input placeholder="Zip Code" />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Country" required>
                        <Select rows={3} />
                      </Form.Item>
                      <Form.Item label="Resided From">
                        <Row gutter={[8, 0]}>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Resided To">
                        <Row gutter={[8, 0]}>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Monthly Rent">
                        <InputNumber
                          addonBefore={<TbCurrencyDollar size={16} />}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Form.Item label="Landlord Name">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Landlord Phone Number">
                        <Input></Input>
                      </Form.Item>
                      <Form.Item label="Landlord Email Address">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Reason For Leaving">
                        <TextArea rows={3} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <FormAction cancel={onCancel} />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col span={24}>
                      <Form.Item label="Current Address">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Resided">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Monthly Rent">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Landlord">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Reason for leaving">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Last Verification Emailed">
                        <p>--</p>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Card>
            </Col>
            <Col span={24}>
              <Card
                extra={
                  !edit ? (
                    <span
                      className="onclick-text"
                      onClick={() => setEdit(true)}
                    >
                      Edit
                    </span>
                  ) : null
                }
              >
                {edit ? (
                  <Row>
                    <Col span={24}>
                      <Form.Item label="Previous Address" required>
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <Input placeholder="Address" />
                          </Col>
                          <Col span={24}>
                            <Input placeholder="Address 2" />
                          </Col>
                          <Col span={24}>
                            <Row gutter={[8, 0]}>
                              <Col span={10}>
                                <Input placeholder="City" />
                              </Col>
                              <Col span={4}>
                                <Select options={states} />
                              </Col>
                              <Col span={10}>
                                <Input placeholder="Zip Code" />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Country" required>
                        <Select rows={3} />
                      </Form.Item>
                      <Form.Item label="Resided From">
                        <Row gutter={[8, 0]}>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Resided To">
                        <Row gutter={[8, 0]}>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Monthly Rent">
                        <InputNumber
                          addonBefore={<TbCurrencyDollar size={16} />}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Form.Item label="Landlord Name">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Landlord Phone Number">
                        <Input></Input>
                      </Form.Item>
                      <Form.Item label="Landlord Email Address">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Reason For Leaving">
                        <TextArea rows={3} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <FormAction cancel={onCancelEdit} />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col span={24}>
                      <Form.Item label="Previous Address">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Resided">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Monthly Rent">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Landlord">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Reason for leaving">
                        <p>--</p>
                      </Form.Item>
                      <Form.Item label="Last Verification Emailed">
                        <p>--</p>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Card>
            </Col>
            <Col span={24}>
              {addPrevAddress ? (
                <Card>
                  <Row>
                    <Col span={24}>
                      <Form.Item label="Previous Address" required>
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <Input placeholder="Address" />
                          </Col>
                          <Col span={24}>
                            <Input placeholder="Address 2" />
                          </Col>
                          <Col span={24}>
                            <Row gutter={[8, 0]}>
                              <Col span={10}>
                                <Input placeholder="City" />
                              </Col>
                              <Col span={4}>
                                <Select options={states} />
                              </Col>
                              <Col span={10}>
                                <Input placeholder="Zip Code" />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Country" required>
                        <Select rows={3} />
                      </Form.Item>
                      <Form.Item label="Resided From">
                        <Row gutter={[8, 0]}>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Resided To">
                        <Row gutter={[8, 0]}>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                          <Col span={12}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Form.Item>
                      <Form.Item label="Monthly Rent">
                        <InputNumber
                          addonBefore={<TbCurrencyDollar size={16} />}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Form.Item label="Landlord Name">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Landlord Phone Number">
                        <Input></Input>
                      </Form.Item>
                      <Form.Item label="Landlord Email Address">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Reason For Leaving">
                        <TextArea rows={3} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <FormAction cancel={onCancelPrevAddress} />
                    </Col>
                  </Row>
                </Card>
              ) : (
                <button
                  onClick={() => setAddPrevAddress(true)}
                  className="add-icon-btn"
                >
                  <span>Add Previous Address</span>
                </button>
              )}
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default ResidentialHistory;
